interface Props {
  current: number; // 0-based question index
  total: number;
}

export function ProgressBar({ current, total }: Props) {
  const pct = total === 0 ? 0 : Math.min((current / total) * 100, 100);

  return (
    <div className="progress-bar">
      <div className="progress-bar__row">
        <div className="progress-bar__track">
          <div className="progress-bar__fill" style={{ width: `${pct}%` }} />
        </div>
        <span className="progress-bar__label">
          {current}/{total}
        </span>
      </div>
    </div>
  );
}
